import { isNil } from '@flowio/is';
import { parseQueryString } from '@flowio/web-sdk';
import { ValueOf } from '../types';

export const flowEnvironment = {
  Development: 'development',
  Production: 'production',
  Test: 'test',
} as const;

export type FlowEnvironment = ValueOf<typeof flowEnvironment>;

/**
 * process.env.FLOW_ENV is a build time var.
 * querystring `flow_env` is a runtime var.
 */

export default function getEnvironment(): FlowEnvironment {
  const params = parseQueryString<{ flow_env?: string }>(window.location.search);
  const found = Object.values(flowEnvironment).find((value) => value === params.flow_env);

  return (!isNil(found))
    ? found : (process.env.FLOW_ENV as FlowEnvironment || flowEnvironment.Production);
}
